module.exports = __webpack_public_path__ + "static/media/venus.6f1d5d18.webp";